import { FormID } from './action-form';
import { Persona } from './persona';

// tslint:disable-next-line: no-namespace
export namespace Constants {
  /**
   * Default limit
   */
  export const DefaultLimit = 25;

  /**
   * Default page size options
   */
  export const PageSizeOptions = [25, 50, 100];

  /**
   * Default date time format
   */
  export const DateTimeFormat = 'DD/MM/YYYY HH:mm';

  /**
   * Default date format
   */
  export const DateFormat = 'DD/MM/YYYY';

  /**
   * Default time format
   */
  export const TimeFormat = 'HH:mm';

  /**
   * The map of request persona with ID.
   * The same with id in DB.personas
   */
  export const RequestPersona = {
    ISOTankDepot: 2,
    ISOTankProvider: 3,
    Shipper: 6,
    TruckingCompany: 8,
  };

  /**
   * The map of weighbridge type.
   */
  export const WeighbridgeType = {
    Form: 0,
    Attachment: 1,
  };

  /**
   * The map of payment type.
   */
  export const PaymentType = {
    account: 0,
    cash: 1,
  };

  /**
   * The map of Eir type.
   */
  export const EirType = {
    Direct: 0,
    Indirect: 1,
  };

  export const OrderBy = {
    asc: 'ASC',
    desc: 'DESC',
  };

  export const SortBy = {
    expectedDate: 'expected_date',
    expectedStartDate: 'expected_start_date',
    modifiedDate: 'modified_date',
    actualDate: 'actual_date',
    createdDate: 'created_date',
    name: 'name',
    id: 'id',
    personaName: 'persona_name',
  };

  export const getConfirmConfig = (
    message,
    confirmBtn?,
    cancelBtn?
  ) => {
    if (!message) {
      message = 'confirm.description';
    }
    if (!confirmBtn) {
      confirmBtn = 'confirm.confirm_btn';
    }
    if (!cancelBtn) {
      cancelBtn = 'confirm.cancel_btn';
    }
    return {
      message,
      showCancelButton: true,
      showConfirmButton: true,
      confirmText: confirmBtn,
      cancelText: cancelBtn,
      reverseButtons: true, // swap confirm-cancel button
    };
  };

  export const AlertCommonStyle = {
    title: 'title',
    popup: 'alert-popup',
    content: 'alert-content',
    cancelButton: 'btn btn-secondary',
    confirmButton: 'btn btn-primary',
  };

  export const Validators = {
    PATTERN: {
      email: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
      password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-"!@#%&\,><\':;|_~`])\S{6,99}$/
    }
  };
  export const RegulatoryStatus = {
    FOR_VALIDATION: 1,
    ACCEPTED: 2,
    REJECTED: 3,
    EXPIRED: 4
  }
  export const RegulatoryStatusName = [
    { text: 'For validation', value: RegulatoryStatus.FOR_VALIDATION },
    { text: 'Accepted', value: RegulatoryStatus.ACCEPTED },
    { text: 'Rejected', value: RegulatoryStatus.REJECTED },
    { text: 'Expired', value: RegulatoryStatus.EXPIRED },
  ];

  export const TransactionType = {
    INPDEC: 'INPDEC',
    IPTDEC: 'IPTDEC',
    OUTDEC: 'OUTDEC',
  };
  export const TransactionStatus = {
    DRAFT: 1,
    FOR_VALIDATION: 2,
    FOR_VALIDATION_MISS_INFO: 3,
    ACCEPTED: 4,
    REJECTED: 5,
  };
  export const TransactionStatusName = [
    { text: 'Draft', value: TransactionStatus.DRAFT },
    { text: 'For Validation', value: TransactionStatus.FOR_VALIDATION },
    { text: 'For Validation - Missing info', value: TransactionStatus.FOR_VALIDATION_MISS_INFO },
    { text: 'Accepted', value: TransactionStatus.ACCEPTED },
    { text: 'Rejected', value: TransactionStatus.REJECTED },
  ];
  export const TransportMode = {
    SEA: '1',
    RAIL: '2',
    ROAD: '3',
    AIR: '4',
    MAIL: '5',
    MULTI: '6',
    PIPELINE: '7',
  };

  export const STATUS_MODE = {
    NEW: 'NEW',
    EDIT: 'EDIT',
    VIEW: 'VIEW'
  };

  export const locodesDefaultParams = {
    offset: 0,
    limit: 100,
    sort: ['code ASC', 'name ASC'],
    where: {},
    q: ''
  };

  export const JOURNEY_MAIN_ACTIONS = {
    1: {
      // Consignee
      actions: [
        12, // Unload Product
      ],
      error: 'Unload Product action is required',
    },
    2: {
      // ISO Tank Depot
      actions: [
        2, // Lift On
        10, // Lift Off
      ],
      error: 'At least Lift On or Lift Off should be selected',
    },
    4: {
      // Port
      actions: [
        3, // Gate In
        7, // Gate Out
      ],
      error: 'At least Gate In or Gate Out should be selected',
    },
    5: {
      // Railhead
      actions: [
        3, // Gate In
        7, // Gate Out
      ],
      error: 'At least Gate In or Gate Out should be selected',
    },
    6: {
      // Shipper
      actions: [
        5, // Load Product
      ],
      error: 'Load Product action is required',
    },
    11: {
      // Bulk
      actions: [
        14, // On Loading
        15, // Off Loading
      ],
      error: 'At least On Loading or Off Loading should be selected',
    },
  };

  export const MAX_PERSONA = 15;

  export const ALLOWED_ACTIONS_FOR_NO_LOCATION = [
    FormID.BOL,
    // FormID.EIR,
    FormID.VESSEL_ARRIVAL,
    FormID.VESSEL_DEPARTURE,
    FormID.CARGO_COLLECTION,
    FormID.CARGO_DELIVERY,
    FormID.DGD
  ];

  export const CARGO_FORM = [
    FormID.CARGO_COLLECTION,
    FormID.CARGO_DELIVERY
  ];

  export const ALLOWED_ACTOR_FOR_CARGO_FORM = [
    Persona.AGENT,
    Persona.CARRIER,
    Persona.CONSIGNEE,
    Persona.FREIGHT_FORWARDER,
    Persona.ISO_TANK_DEPOT,
    Persona.LOGISTICS_SERVICE_PROVIDER,
    Persona.PORT,
    Persona.RAILHEAD,
    Persona.BULK_STORAGE_TERMINAL
  ]

  export const ACTIONS_AUTO_ADD_FOR_NO_LOCATION = [
    // FormID.VESSEL_ARRIVAL,
    // FormID.VESSEL_DEPARTURE
  ];

  export const DENIED_ACTIONS_FOR_LOCATION = [
    FormID.VESSEL_ARRIVAL,
    FormID.VESSEL_DEPARTURE,
    FormID.CARGO_COLLECTION,
    FormID.CARGO_DELIVERY
  ];

  export const PERSONAS_CAN_CREATE_FLOW = [
    Persona.LOGISTICS_SERVICE_PROVIDER,
    Persona.SHIPPER,
    Persona.FREIGHT_FORWARDER,
  ];
}
